import dotProps from 'dot-prop-immutable';

import states from './states';
import * as actionTypes from './actiontypes';

const agent_monitoring_details = (state = states.agent_monitoring_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_AGENT_MONITORING_STATE: {
      return dotProps.set(state, action.path, action.payload);
    }

    case actionTypes.UPDATE_AGENT_LIVE_STATS: {
      return {
        ...state,
        expanded_group: {
          ...state.expanded_group,
          agents: action.payload
        },
        loaders: {
          ...state.loaders,
          agent_list_loading: false,
        }
      };
    }

    case actionTypes.AGENT_MONITORING_CUSTOMER_MESSAGE_RECEIVED: {
      let message = {
        ...action.payload.message,
        NLPSnapshot: action.payload.NLPSnapshot ? action.payload.NLPSnapshot : null,
        prevNLPSnapshot: action.payload.prevNLPSnapshot ? action.payload.prevNLPSnapshot : null,
      };

      return {
        ...state,
        selected_agent: {
          ...state.selected_agent,
          active_chat: {
            ...state.selected_agent.active_chat,
            messages: [...state.selected_agent.active_chat.messages, message]
          }
        }
      };
    }

    case actionTypes.AGENT_MONITORING_MESSAGE_RESPONSE_RECEIVED: {
      return {
        ...state,
        selected_agent: {
          ...state.selected_agent,
          active_chat: {
            ...state.selected_agent.active_chat,
            messages: [...state.selected_agent.active_chat.messages, action.payload.message]
          }
        }
      };
    }

    default:
      return state;
  }
};

export default agent_monitoring_details;



// WEBPACK FOOTER //
// ./src/data/redux/agent_monitoring_details/reducers.js